import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import PunchLogin from "@/components/punch/PunchLogin";
import PunchHome from "@/components/punch/PunchHome";

export default function PunchApp() {
  const [state, setState] = useState(null); // null=checking, false=logged out, object=me payload
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/punch/me");
      setState(data);
    } catch {
      setState(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    setLoading(true);
    try { await api.post("/punch/logout"); } catch { /* ignore */ }
    setState(false);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F4F1EC] text-slate-900 font-body" data-testid="punch-app" style={{ fontFamily: "'Space Grotesk', 'IBM Plex Sans', system-ui, sans-serif" }}>
      <div className="max-w-[480px] mx-auto min-h-screen flex flex-col">
        {state === null && <div className="flex-1 flex items-center justify-center text-slate-400 text-sm" data-testid="punch-loading">Loading…</div>}
        {state === false && <PunchLogin onLoggedIn={refresh} />}
        {state && <PunchHome me={state} onRefresh={refresh} onLogout={logout} busy={loading} />}
      </div>
    </div>
  );
}
